import * as msgpack from '@mta/msgpack-js-lib';

export default class ApplicationAccess {
	constructor(
			/** ?int= */ id = null,
			/** ?string= */ username = '',
			/** !boolean= */ accessGranted = false,
			/** ?int= */ idUser = null,
			/** ?int= */ idApp = null,
			/** ExternalUser= */ user = null,
			/** Application= */ app = null
	) {
		/** @member {?int} */
		this.id = id;
		/** @member {?string} */
		this.username = username;
		/** @member {!boolean} */
		this.accessGranted = accessGranted;
		/** @member {?int} */
		this.idUser = idUser;
		/** @member {?int} */
		this.idApp = idApp;
		/** @member {ExternalUser} */
		this.user = user;
		/** @member {Application} */
		this.app = app;
	}

	/**
	 * @param {!object} os
	 * @param {!function} genericTypePackers
	 * @param {Number} __uid__
	 * @return {object}
	 */
	pack(os, genericTypePackers, __uid__) {
		return {
			__uid__: __uid__,
			id: os.writeNullableInt(this.id),
			username: os.writeString(this.username),
			accessGranted: os.writeBoolean(this.accessGranted),
			idUser: os.writeNullableInt(this.idUser),
			idApp: os.writeNullableInt(this.idApp),
			user: os.writeObject(this.user),
			app: os.writeObject(this.app)
		};
	}

	/**
	 * @param {!object} is
	 * @param {ApplicationAccess} value
	 */
	unpack(is, value) {
		if (value.id !== undefined)
			this.id = is.readNullableLong(value.id);
		if (value.username !== undefined)
			this.username = is.readString(value.username);
		if (value.accessGranted !== undefined)
			this.accessGranted = is.readBoolean(value.accessGranted);
		if (value.idUser !== undefined)
			this.idUser = is.readNullableLong(value.idUser);
		if (value.idApp !== undefined)
			this.idApp = is.readNullableLong(value.idApp);
		if (value.user !== undefined)
			this.user = is.readObject(value.user, () => new msgpack.gen.com.arabellesolutions.sdc.b2b.common.user.ExternalUser());
		if (value.app !== undefined)
			this.app = is.readObject(value.app, () => new msgpack.gen.com.arabellesolutions.sdc.b2b.common.application.Application());
	}
}

msgpack.registerClass('com.arabellesolutions.sdc.b2b.common.application.ApplicationAccess', ApplicationAccess);
